module.exports = __webpack_public_path__ + "img/1561005816.025eb875.jpg";